import React from 'react'
import { Redirect, Route, Switch } from 'react-router'

import PaymentsList from './PaymentsList'
import PaymentPreview from './PaymentPreview'

export default function Payments() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/pagos" component={PaymentsList} />
				<Route exact path="/pagos/:id" component={PaymentPreview} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}